import "./App.css";
import React, { Suspense, useContext, useState } from "react";
import { HashRouter as BrowserRouter } from "react-router-dom";

//assets
import logo from "../assets/img/logo.svg";

//routers
import { AppRouter } from "./routers/AppRouter";

//layouts
import { MobileContainer } from "../shared/layouts/MobileContainer";

//Data Display
import { LoadingAlert } from "../shared/data_display/LoadingAlert";
import { OrientationWarning } from "../shared/data_display/orientationWarning";

//context
//import { GlobalVars } from "../contexts/GlobalVars";

export default function App() {
  //const globalVars = useContext(GlobalVars)
  document.title = "Pietra-MQ";
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <OrientationWarning />
      {loaded === false && <LoadingAlert />}
      <Suspense fallback={<LoadingAlert />}>
        <BrowserRouter>
          <MobileContainer>            
           {/* <GlobalVars.Provider value={globalVars}>*/}
              <AppRouter
                onStartLoadingPage={() => {
                  console.log("----StartLoading");
                  setLoaded(false);
                }}
                onLoad={() => {
                  console.log("----Loaded");
                  setLoaded(true);
                }}
              />
           {/* </GlobalVars.Provider>*/}
          </MobileContainer>
        </BrowserRouter>
      </Suspense>
    </>
  );
}

//export default App;
